import { render, staticRenderFns } from "./Following.vue?vue&type=template&id=13980cd1&"
import script from "./Following.vue?vue&type=script&lang=js&"
export * from "./Following.vue?vue&type=script&lang=js&"
import style0 from "./Following.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports